module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/ramda/src/internal/_isObject.js
// module id = ../../node_modules/ramda/src/internal/_isObject.js
// module chunks = 18